import { Alert, Box, Button, Checkbox, CircularProgress, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import requests from "api/requests";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useMemo, useState } from "react";
import { CarServicesSerializer } from "./types";
import ServiceItem from "pages/driver/serviceItem";
import { IService } from "pages/driver/types";

interface IProps {
  carID: number;
  tariffClass?: number;
}


export default function Services(props: IProps) {
  const {
    carID,
    tariffClass
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [services, setServices] = useState<IService[] | null>(null);
  const [carServices, setCarServices] = useState<CarServicesSerializer | null>(null);
  const [initCarServices, setInitCarServices] = useState<CarServicesSerializer | null>(null);
  const [disable, setDisable] = useState(false);

  const mergeServices = useCallback((s: CarServicesSerializer): CarServicesSerializer => {
    if (s.request_services !== null && s.request_services !== undefined) {
      s.services = s.request_services
    }
    return JSON.parse(JSON.stringify(s))
  }, [])

  useEffect(() => {
    requests.get('/base/service/', {
      autouses: true,
      displayindriversaccount: true,
      tariffclassid__isnull_or_equal: tariffClass || undefined
    }).then((r) => setServices(r.body))
  }, [tariffClass])

  useEffect(() => {
    requests.get(`/base/car-card/${carID}/services/`).then((r) => {
      setCarServices(mergeServices(r.body))
      setInitCarServices(mergeServices(r.body))
    })
  }, [carID, mergeServices])

  const requestExists = useMemo(() => {
    if (!!(carServices?.request_services || []).length) {
      return true
    }
    return false;
  }, [
    carServices,
  ])

  const equals = useCallback((a: any[], b: any[]) => {
    return a.length === b.length && !Boolean(a.filter((v) => !b.includes(v)).length)
  }, [])

  const differentExists = useMemo(() => {
    if (!equals(carServices?.services || [], initCarServices?.services || [])) {
      return true;
    }
    return false;
  }, [
    carServices,
    initCarServices,
    equals
  ])

  const save = () => {
    setDisable(true);
    requests.put(`/base/car-card/${carID}/services/`, {
      "request_services": carServices?.services || []
    }).then((r) => {
      setCarServices(mergeServices(r.body));
      setInitCarServices(mergeServices(r.body));
      if (r.body.request_services === null) {
        enqueueSnackbar("Збережено", { variant: 'success' });
      } else {
        enqueueSnackbar("Заявку на зміни надіслано", { variant: 'success' });
      }
    }).finally(() => {
      setDisable(false);
    })
  }

  if (services === null || carServices === null) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box>
      <List
        disablePadding
        sx={{
          columns: {
            xs: 1,
            sm: 2,
            md: 3
          },
          ">div": {
            display: 'inline-flex',
            width: '100%',
          },
        }}
      >
        {services.map((service) => {
          return (
            <ListItemButton
              key={service.id}
              dense
              onClick={() => {
                var index = carServices.services.indexOf(service.id);
                if (index === -1) {
                  carServices.services.push(service.id)
                } else {
                  carServices.services.splice(index, 1);
                }
                setCarServices({ ...carServices })
              }}
              disabled={disable || requestExists}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={carServices.services.includes(service.id)}
                />
              </ListItemIcon>
              <ListItemText primary={<ServiceItem service={service} />} />
            </ListItemButton>
          );
        })}
      </List>
      <Box sx={{
        mt: 2
      }}>
        {!!requestExists ? (
          <Alert severity="info">
            <b>Ваша заявка в черзі на опрацювання</b><br />
            Ви не можете вносити зміни доки не буде опряцьована попередня заявка
          </Alert>
        ) : (
          <Button
            variant="contained"
            color="secondary"
            onClick={save}
            disabled={disable || !differentExists}
          >Зберегти</Button>
        )}
      </Box>
    </Box>
  )
}